import { A as u, c as b } from "./chunk-aria-live-region-context-BqflDy8u.js";
import { c as f, a as _ } from "./chunk-cart-sections-DRoqu5V0.js";
import { m as S } from "./chunk-modal-context-Bix0LJYF.js";
import { c as L } from "./chunk-quickshop-DplCITqN.js";
import { s as C } from "./chunk-context-request-event-Dgp0q6kL.js";
import { i as x } from "./chunk-lit-element-fTUROFeD.js";
import { t as P } from "./chunk-custom-element-BugcqQdL.js";
import { r as d } from "./chunk-state-mgWPrzy6.js";
class O {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, s = !1) {
    const o = s || !Object.is(t, this.o);
    this.o = t, o && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s, { disposer: o }] of this.subscriptions) s(this.o, o);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, s, o) {
    if (!o) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: s });
    const { disposer: i } = this.subscriptions.get(t);
    t(this.value, i);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
let w = class extends Event {
  constructor(t, s) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = s;
  }
};
class g extends O {
  constructor(t, s, o) {
    super(s.context !== void 0 ? s.initialValue : o), this.onContextRequest = (i) => {
      if (i.context !== this.context) return;
      const n = i.contextTarget ?? i.composedPath()[0];
      n !== this.host && (i.stopPropagation(), this.addCallback(i.callback, n, i.subscribe));
    }, this.onProviderRequest = (i) => {
      if (i.context !== this.context || (i.contextTarget ?? i.composedPath()[0]) === this.host) return;
      const n = /* @__PURE__ */ new Set();
      for (const [a, { consumerHost: r }] of this.subscriptions) n.has(a) || (n.add(a), r.dispatchEvent(new C(this.context, r, a, !0)));
      i.stopPropagation();
    }, this.host = t, s.context !== void 0 ? this.context = s.context : this.context = s, this.attachListeners(), this.host.addController?.(this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new w(this.context, this.host));
  }
}
function p({ context: e }) {
  return (t, s) => {
    const o = /* @__PURE__ */ new WeakMap();
    if (typeof s == "object") return { get() {
      return t.get.call(this);
    }, set(i) {
      return o.get(this).setValue(i), t.set.call(this, i);
    }, init(i) {
      return o.set(this, new g(this, { context: e, initialValue: i })), i;
    } };
    {
      t.constructor.addInitializer(((a) => {
        o.set(a, new g(a, { context: e }));
      }));
      const i = Object.getOwnPropertyDescriptor(t, s);
      let n;
      if (i === void 0) {
        const a = /* @__PURE__ */ new WeakMap();
        n = { get() {
          return a.get(this);
        }, set(r) {
          o.get(this).setValue(r), a.set(this, r);
        }, configurable: !0, enumerable: !0 };
      } else {
        const a = i.set;
        n = { ...i, set(r) {
          o.get(this).setValue(r), a?.call(this, r);
        } };
      }
      return void Object.defineProperty(t, s, n);
    }
  };
}
var A = Object.defineProperty, D = Object.getOwnPropertyDescriptor, c = (e, t, s, o) => {
  for (var i = o > 1 ? void 0 : o ? D(t, s) : t, n = e.length - 1, a; n >= 0; n--)
    (a = e[n]) && (i = (o ? a(t, s, i) : a(i)) || i);
  return o && i && A(t, s, i), i;
};
const l = {
  OPEN: "modal-dialog::open",
  CLOSE: "modal-dialog::close",
  CLOSE_ALL: "modal-dialog::close-all"
}, m = {
  UPDATED: "cart:updated",
  UPDATED_SECTIONS: "cart:updated-sections"
}, E = {
  OPEN: "quickshop::open",
  CLOSE: "quickshop::close"
}, v = "modals";
let h = class extends x {
  constructor() {
    super(...arguments), this.cart = window.__CART__, this.cartSections = {}, this.modals = [], this.quickShop = null;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    this.addEventListener(
      m.UPDATED,
      this._handleCartUpdate.bind(this)
    ), this.addEventListener(
      m.UPDATED_SECTIONS,
      this._handleCartSectionsUpdate.bind(this)
    ), this.addEventListener(
      u.SET,
      this._handleAriaLiveRegionSet.bind(this)
    ), this.addEventListener(
      u.CLEAR,
      this._handleAriaLiveRegionClear.bind(this)
    ), this.addEventListener(
      "click",
      this._handleDialogSchemaClick.bind(this)
    ), Object.values(l).forEach((e) => {
      this.addEventListener(
        e,
        this._handleDialogEvent.bind(this)
      );
    }), Object.values(E).forEach((e) => {
      this.addEventListener(
        e,
        this._handleQuickShopEvent.bind(this)
      );
    }), this._handleRestoreModals();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener(
      m.UPDATED,
      this._handleCartUpdate.bind(this)
    ), this.removeEventListener(
      m.UPDATED_SECTIONS,
      this._handleCartSectionsUpdate.bind(this)
    ), this.removeEventListener(
      u.SET,
      this._handleAriaLiveRegionSet.bind(this)
    ), this.removeEventListener(
      u.CLEAR,
      this._handleAriaLiveRegionClear.bind(this)
    ), this.removeEventListener(
      "click",
      this._handleDialogSchemaClick.bind(this)
    ), Object.values(l).forEach((e) => {
      this.removeEventListener(
        e,
        this._handleDialogEvent.bind(this)
      );
    }), Object.values(E).forEach((e) => {
      this.removeEventListener(
        e,
        this._handleQuickShopEvent.bind(this)
      );
    });
  }
  _handleCartUpdate(e) {
    e.detail && (this.cart = e.detail);
  }
  _handleCartSectionsUpdate(e) {
    e.detail && (this.cartSections = e.detail || {});
  }
  _handleDialogSchemaClick(e) {
    const t = e.composedPath(), s = t.length > 0 ? t[0] : e.target;
    if (s.tagName === "A") {
      const o = s.getAttribute("href");
      if (o && (o.startsWith("modal-dialog://") || o.startsWith("#modal-dialog://"))) {
        e.preventDefault();
        const i = o.replace("modal-dialog://", "").replace("#", "");
        i && this._handleDialogEvent(
          new CustomEvent(l.OPEN, { detail: i })
        );
      }
    }
  }
  _handleDialogEvent(e) {
    let t = [...this.modals];
    switch (e.type) {
      case l.OPEN:
        e.detail && (t = [...t, e.detail]);
        break;
      case l.CLOSE:
        e.detail && (t = t.filter((s) => s !== e.detail)), this.quickShop = null;
        break;
      case l.CLOSE_ALL:
        t = [], this.quickShop = null;
        break;
    }
    t = [...new Set(t)], this.modals = t, this._applyModalsState(), this._updateQueryParams();
  }
  async _applyModalsState() {
    await customElements.whenDefined("modal-dialog");
    const e = this.modals, t = Array.from(
      this.querySelectorAll("modal-dialog")
    );
    for (const s of t)
      e.includes(s.id) ? s.show() : s.hide();
  }
  _handleRestoreModals() {
    const t = new URLSearchParams(window.location.search).get(v);
    t && (this.modals = t.split(",").map((s) => s.trim()).filter(Boolean), this._applyModalsState());
  }
  _updateQueryParams() {
    const e = new URLSearchParams(window.location.search), t = this.modals, s = this.modals.join(",");
    t.length > 0 ? e.set(v, s) : e.delete(v);
    const o = `${window.location.pathname}?${e.toString()}`;
    window.history.replaceState({}, "", o);
  }
  _handleAriaLiveRegionSet(e) {
    e.detail && (this.ariaLiveRegion = e.detail);
  }
  _handleAriaLiveRegionClear() {
    this.ariaLiveRegion = {
      message: ""
    };
  }
  _handleQuickShopEvent(e) {
    const t = e.type, s = e.detail;
    t === E.OPEN ? this.quickShop = s : this.quickShop = null;
  }
};
c([
  p({ context: f }),
  d()
], h.prototype, "cart", 2);
c([
  p({ context: _ }),
  d()
], h.prototype, "cartSections", 2);
c([
  p({ context: S }),
  d()
], h.prototype, "modals", 2);
c([
  p({ context: b }),
  d()
], h.prototype, "ariaLiveRegion", 2);
c([
  p({ context: L }),
  d()
], h.prototype, "quickShop", 2);
h = c([
  P("app-provider")
], h);
export {
  h as AppProvider
};
